import { create } from "zustand";
import dayjs from "dayjs";
const today = dayjs();
const oneWeekAgo = today.subtract(7, "day");
const yesterday = dayjs().subtract(1, "day");
export const useReportsStore = create((set) => ({
  auditReportRangeFilter: [oneWeekAgo, today],
  setAuditReportRangeFilter: (value) => {
    set({ auditReportRangeFilter: value });
  },
  auditFirstRender: true,
  setAuditFirstRender: (value) => {
    set({ auditFirstRender: value });
  },
  alarmReportSelectFilter: yesterday,
  setAlarmReportSelectFilter: (value) => {
    set({ alarmReportSelectFilter: value });
  },
  alarmReportUserType: "All USERS",
  setAlarmReportUserType: (value) => {
    set({ alarmReportUserType: value });
  },
  alarmReportFirstRender: true,
  setAlarmFirstRender: (value) => {
    set({ alarmReportFirstRender: value });
  },
  dailyStatsReportSelectFilter: yesterday,
  setDailyStatsReportSelectFilter: (value) => {
    set({ dailyStatsReportSelectFilter: value });
  },
  dailyStatsReportUserType: "All USERS",
  setDailyStatsReportUserType: (value) => {
    set({ dailyStatsReportUserType: value });
  },
  dailyStatsReportFirstRender: true,
  setDailyStatsFirstRender: (value) => {
    set({ dailyStatsReportFirstRender: value });
  },
  jslStatsSelectFilter: yesterday,
  setJslStatsSelectFilter: (value) => {
    set({ jslStatsSelectFilter: value });
  },

  jslStatsFirstRender: true,
  setJslStatsFirstRender: (value) => {
    set({ jslStatsFirstRender: value });
  },
  tab: 1,
  setTab: (value) => {
    set({ tab: value });
  },
  gatewiseSerialNo: "",
  setGatewiseSerialNo: (value) => {
    set({ gatewiseSerialNo: value });
  },
  gatewiseFirstRender: "",
  setGatewiseFirstRender: (value) => {
    set({ gatewiseFirstRender: value });
  },
  siSerialNo: "",
  setSiSerialNo: (value) => {
    set({ siSerialNo: value });
  },
  siFirstRender: "",
  setSiFirstRender: (value) => {
    set({ siFirstRender: value });
  },
}));
